import React from 'react';
import { EMASatisfactionType } from '@demind-inc/core';
import { getSatisfactionIcon, satisfactionOptions } from '../../../../DataView/constants';
import './AnswerSatisfactionPopup.scss';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import { selectedDateAtom } from '../../../../../data-access/recoil/atoms';

interface AnswerSatisfactionPopupProps {
  defaultValue?: EMASatisfactionType | null;
  onSelect: (value: EMASatisfactionType) => void;
  className?: string;
}

const AnswerSatisfactionPopup: React.FC<AnswerSatisfactionPopupProps> = ({
  defaultValue = null,
  onSelect,
  className,
}) => {
  const selectedDate = useRecoilValue(selectedDateAtom);
  const isFutureDate = dayjs(selectedDate).isAfter(dayjs());

  return (
    <div className={clsx('answer-satisfaction-popup', className)}>
      {satisfactionOptions.map((value) => (
        <button
          key={value}
          className={`answer-satisfaction-popup__button`}
          onClick={() => onSelect(value)}
          disabled={isFutureDate}
        >
          {getSatisfactionIcon(
            value,
            defaultValue === value ? 'selected' : 'unselected',
            18,
            'answer-satisfaction-popup__button__icon'
          )}
        </button>
      ))}
    </div>
  );
};

export default AnswerSatisfactionPopup;
